import { Pipe, PipeTransform } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';

@Pipe({
  name: 'combinedLoading',
})
export class CombinedLoadingPipe implements PipeTransform {
  transform(observables: Observable<boolean>[]): Observable<boolean> {
    return combineLatest(observables).pipe(map((values: boolean[]) => values.some(Boolean)));
  }
}
